module.exports = "/assets/fd4ea5221abef3f741e25f87dbf5707e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/icon/error.png
// module id = 482
// module chunks = 0